import React, { Suspense } from "react";
import ImageContanosLogo from "../assets/svg/contanos-logo.svg";
import { makeStyles } from "@mui/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import LogoErrepar from "../assets/svg/logo-errepar";
import ImageContanosLogoMobile from "../assets/svg/contanos-logo-mobile.svg";

import theme from "../theme/theme";
import ButtonCustom from "../components/buttons/Button";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const useStyle = makeStyles({
  containerLogo: {
    display: "flex",
    alignItems: "center",
    marginTop: "3rem",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      marginTop: "1rem",
      marginBottom: "1rem",
      paddingLeft: "5%",
    },
  },
  logo: {
    width: "19rem",
    [theme.breakpoints.down("md")]: {
      width: "12rem",
    },
  },
  containerTitle: {
    width: "100%",
    height: "80%",
    paddingTop: "2rem",
  },
  title: {
    fontWeight: "bold",
    fontSize: "40px",
    color: "#263057",
    lineHeight: "46.96px",
    [theme.breakpoints.down("md")]: {
      fontSize: "40px",
    },
  },
  subtitle: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#263057",
    lineHeight: "21.13px",
    marginBottom: "3rem",
  },
  containerButtonSimple: {
    display: "flex",
    alignItems: "center",
    marginTop: "2rem",
    [theme.breakpoints.down("md")]: {
      marginRight: "0rem",
    },
  },
});
export const ProviderLoginError = () => {
  const classes = useStyle();
  const media = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      {media && (
        <>
          <div className={classes.containerLogo}>
            <div className={classes.logo}>
              <LogoErrepar />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2rem 0px",
            }}
          >
            <img
              src={ImageContanosLogoMobile}
              loading="lazy"
              title="contanos-sobre-vos"
              alt="Contanos sobre vos"
            />
          </div>
        </>
      )}
      <div style={{ display: "flex", height: "100%" }}>
        {!media && (
          <div
            style={{
              background: "#ECECEC",
              width: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={ImageContanosLogo}
              loading="lazy"
              title="contanos-sobre-vos"
              alt="Contanos sobre vos"
              height="80%"
              width="80%"
            />
          </div>
        )}
        <div style={{ width: media ? '100%' : "50%", paddingLeft: "5%" }}>
          {!media && (
            <div className={classes.containerLogo}>
              <div className={classes.logo}>
                <LogoErrepar />
              </div>
            </div>
          )}

          <div className={classes.containerTitle}>
            <div>
              <h1 className={classes.title}>¡Lo sentimos!</h1>
              <p className={classes.subtitle} >
                Hubo un problema con el acceso a través de Google.
              </p>
              <h2 className={classes.title} style={{ fontSize: "18px" }}>
              Si ya tenés cuenta en Errepar+, iniciá sesión
              </h2>

              <ButtonCustom
                onClick={() => navigate("/")}
                fontSize={16}
                label={"INICIÁ SESIÓN"}
                borderRadius={23}
                background={"#24378F"}
                color="#fff"
                width={media ? '90%' : 211}
                className={{
                  textAlign: "center",
                  lineHeight: "21.13px",
                  letterSpacing: "5%",
                  [theme.breakpoints.down("md")]: {
                    fontSize: "14px",
                  },
                }}
              ></ButtonCustom>
              <Box className={classes.containerButtonSimple}>
                <Suspense fallback={<div></div>}>
                  <p>¿No tenés una cuenta?</p>
                  <ButtonCustom
                    className={classes.disableHoverEffect}
                    boldDisabled={false}
                    onClick={() => navigate("/register")}
                    fontSize={16}
                    label={"Creá tu cuenta"}
                    color={"#263057"}
                    disableRipple={true}
                  ></ButtonCustom>
                </Suspense>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
